export default "__VITE_ASSET__AacPE9Nm__"